<script>
export default {
	name: 'MABAHomepageLayout',
	expose: [],
	inheritAttrs: false,
};
</script>

<script setup>
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';
import ExperienceFragment from '~/aem-components/ExperienceFragment.vue';
import BtnBackToTop from '~/components/BtnBackToTop.vue';
import { gsap } from 'gsap';
import { useEventBus } from '@vueuse/core';
import { generateXfPath } from '@/logic/aem/generate-xf-path';

import Carousel from '~/aem-components/Carousel.vue';



const rootEl = ref(null);

const { isEditorMode } = useGlobalAEMState();
const siteName = window.siteName;

</script>


<template>
<div ref="rootEl" class="MABAHomepageLayout flex flex-col min-h-screen" data-layout="MABAHomepage">
	<ExperienceFragment
		class="global-header-notification"
		:xfPath="generateXfPath({ siteName, xfComponentId: 'header-notification' })"
	/>
	<div class="sticky-spacer h-$headerNotificationHeight"></div>
	
	<ExperienceFragment
		class="global-header"
		:xfPath="generateXfPath({ siteName, xfComponentId: 'header' })"
	/>
	
	<div id="content"></div>
	<main>
		<slot></slot>
	</main>
	
	<div class="floating-bottom-right-container">
		<BtnBackToTop />
	</div>
	
	<ExperienceFragment
		class="global-cookies-notification"
		:xfPath="generateXfPath({ siteName, xfComponentId: 'cookies-notification' })"
	/>
	<ExperienceFragment
		class="global-footer"
		:xfPath="generateXfPath({ siteName, xfComponentId: 'footer' })"
	/>
</div>
</template>



<style scoped lang="scss">
@use '~/styles/partials/_var.scss';

:slotted(.page) {
	min-height: 400px;
}

</style>
